export enum OmEmeaRequestPriorityLevel {
    MEDIUM = 'Medium',
    HIGH = 'High',
    VERY_HIGH = 'Very High'
}
